import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/tech-logs/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
